import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=6308d703"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"
import style0 from "./CustomerView.vue?vue&type=style&index=0&id=6308d703&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports